var _path, _path2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErrorCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 20C0 8.95431 8.95431 0 20 0C31.0457 0 40 8.95431 40 20C40 31.0457 31.0457 40 20 40C8.95431 40 0 31.0457 0 20Z",
    fill: "url(#paint0_linear_15167_20747)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7386 12.9596C18.8533 13.0916 18.9563 13.2113 19.0471 13.3175C19.2569 13.0139 19.5423 12.6023 19.8958 12.0952C20.7108 10.9262 21.8884 9.24916 23.3391 7.21666C23.9074 6.42038 25.0041 5.95518 25.9944 6.50465C26.5833 6.83138 27.2861 7.33828 27.8396 8.0927C28.3886 8.84094 28.2268 9.78163 27.7991 10.4296C24.588 15.2944 22.2704 18.2575 20.9802 19.7992C20.1363 20.8078 18.662 20.8778 17.7148 19.9796C16.4704 18.7996 14.4863 16.8058 12.4225 14.2783C11.842 13.5673 11.6702 12.4885 12.3091 11.6699C12.7234 11.1389 13.1918 10.6891 13.6085 10.3372C14.5289 9.56011 15.8151 9.76974 16.5775 10.5773C17.4954 11.5497 18.2315 12.3758 18.7386 12.9596Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15167_20747)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.4346 23.79C21.2975 23.6813 21.1742 23.5826 21.0654 23.495C20.9151 23.8321 20.7104 24.2891 20.4564 24.8526C19.8706 26.1518 19.022 28.017 17.9704 30.2819C17.5585 31.1692 16.5662 31.8285 15.4917 31.4708C14.8527 31.2581 14.0686 30.8893 13.3856 30.2497C12.7082 29.6154 12.694 28.661 12.995 27.9453C15.2552 22.5724 16.9875 19.2331 17.9716 17.4801C18.6154 16.3334 20.0515 15.9931 21.1479 16.7015C22.5884 17.6321 24.9057 19.2264 27.3997 21.3306C28.1013 21.9225 28.4688 22.9512 27.9917 23.8735C27.6822 24.4716 27.3047 25.0001 26.9599 25.4226C26.1983 26.356 24.8955 26.3868 23.9975 25.7334C22.9161 24.9467 22.0405 24.2703 21.4346 23.79Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_15167_20747",
    x1: 20,
    y1: 0,
    x2: 20,
    y2: 40,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FB1212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DD5D3D"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15167_20747"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(30.5039 30.1885) rotate(169.387)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorCircle);
export default __webpack_public_path__ + "static/media/errorCircle.af28c5fc507db39d81e2fe27b35d2182.svg";
export { ForwardRef as ReactComponent };